export default __webpack_public_path__ + "static/media/background-appoinment.603e5463.jpg";